import { render } from "./GeneratePassports.vue?vue&type=template&id=79f5e56b&scoped=true"
import script from "./GeneratePassports.vue?vue&type=script&lang=js"
export * from "./GeneratePassports.vue?vue&type=script&lang=js"

import "./GeneratePassports.vue?vue&type=style&index=0&id=79f5e56b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f5e56b"]])

export default __exports__